module.exports = __webpack_public_path__ + "img/Small-Bevel-Attachment-43.1f52a3df.png";